import axiosInstance from "../helpers/api";
import * as url from "../helpers/url_helper";

export const getRealTimeData = async () => {
  try {
    const response = await axiosInstance.get(url.GET_REAL_TIME_DATA);
    return response.data;
  } catch (error: any) {
    console.log("errorerrorerror", error);
    return error.response;
  }
};

export const getOnlineChipsData = async () => {
  try {
    const response = await axiosInstance.get(url.GET_ONLINE_CHIP_DATA);
    return response.data;
  } catch (error: any) {
    console.log("errorerrorerror", error);
    return error.response;
  }
};

export const getOfflineChipsData = async () => {
  try {
    const response = await axiosInstance.get(url.GET_OFFLINE_CHIP_DATA);
    return response.data;
  } catch (error: any) {
    console.log("errorerrorerror", error);
    return error.response;
  }
};

export const getMQTTData = async () => {
  try {
    const response = await axiosInstance.get(url.GET_MQTT_DATA);
    return response.data;
  } catch (error: any) {
    console.log("errorerrorerror", error);
    return error.response;
  }
};
